<template src="./auditFSC.html"></template>

<script>
// Pagina "Audit FSC annuale": elenco dei clienti con certificazione FSC di gruppo e delle relative
// edizioni di audit gia' programmate (WEB_ProgrammazioneAudit), da cui si apre la compilazione.
// Accessibile ad admin e auditor (mai al ruolo "utente"); l'anagrafica domande e' riservata all'admin.
import { get_elencoClienti_auditFSC } from "@/api/api.auditFSC.js";
import AnagraficaAuditFSC from "./AnagraficaAuditFSC.vue";

export default {
    components: { AnagraficaAudit: AnagraficaAuditFSC },

    data: () => ({
        loading: false,
        clienti: [],
        ricerca: "",
        dialogAnagrafica: false,
    }),

    methods: {
        async caricaDati() {
            this.loading = true;
            const res = await get_elencoClienti_auditFSC();
            this.clienti = res.data || [];
            this.loading = false;
        },

        apriCompilazione(cliente, edizione) {
            this.$router.push({
                path: `/audit-fsc/compila/${cliente.companyCode}/${edizione.numero}`,
            });
        },

        statoEdizione(edizione) {
            if (edizione.confermata) return { testo: "Confermato", colore: "success" };
            if (edizione.iniziata) return { testo: "In corso", colore: "warning" };
            return { testo: "Da iniziare", colore: "grey" };
        },
    },

    computed: {
        getRole() {
            return this.$store.getters["user/getRole"];
        },

        clientiFiltrati() {
            const ricerca = (this.ricerca || "").toLowerCase().trim();
            if (!ricerca) return this.clienti;
            return this.clienti.filter((c) => (c.ragioneSociale || "").toLowerCase().includes(ricerca));
        },
    },

    created() {
        if (this.getRole !== "admin" && this.getRole !== "auditor") this.$router.push({ path: "/" });
    },

    mounted() {
        this.caricaDati();
    },
};
</script>
